import { useState, useEffect } from "react";

export default function Login() {
  const [error, setError] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const err = params.get("error");

    if (err === "access") {
      setError("❌ Acesso negado: usuário não autorizado");
    }
  }, []);

  const login = () => {
    window.location.href = "/auth/google";
  };

  return (
    <div style={styles.container}>

      <img src="/HITC.png" alt="bg" style={styles.bg} />

      <div style={styles.card}>

        <img
          src="/HITC FUNDO TRANSPARENTE.png"
          alt="logo"
          style={styles.logo}
        />

        <button onClick={login} style={styles.button}>
          Entrar com Google
        </button>

        {error && (
          <div style={styles.error}>
            {error}
          </div>
        )}

      </div>

    </div>
  );
}

/* ================= STYLE ================= */

const styles = {

  container: {
    width: "100%",
    height: "100vh",
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden"
  },

  bg: {
    position: "absolute",
    width: "100%",
    height: "100%",
    objectFit: "cover",
    filter: "brightness(0.35)",
    zIndex: 0
  },

  card: {
    zIndex: 1,
    width: "100%",
    maxWidth: 360,
    background: "rgba(17,24,39,0.92)",
    padding: 30,
    borderRadius: 14,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 14
  },

  logo: {
    width: 120
  },

  button: {
    width: "100%",
    padding: 12,
    background: "#2563eb",
    border: "none",
    borderRadius: 8,
    color: "#fff",
    cursor: "pointer",
    fontWeight: "bold"
  },

  error: {
    width: "100%",
    padding: 10,
    borderRadius: 8,
    background: "rgba(239,68,68,0.15)",
    border: "1px solid rgba(239,68,68,0.4)",
    color: "#f87171",
    fontSize: 13,
    textAlign: "center"
  }
};